import { InitialPendingBookingRequest } from "../types";
import { selectionStore } from "../stores/selection.store";
import { moduleSettings } from "../stores/module-settings.store";
import i18n from "../i18n";
import { getLanguageSwitcherService } from "./language-switcher.service";
import { requestParamsImpl } from "./request-params.service";

class CreatePendingBookingService {
  createInitialPendingBooking(): InitialPendingBookingRequest {
    const area_id = selectionStore.area;
    const isAreaSelectionDisabled = selectionStore.isAreaSelectionDisabled;
    const date = selectionStore.date!.format("YYYY-MM-DD");
    const hour = selectionStore.time;
    const persons = selectionStore.guests + selectionStore.children;
    const children = selectionStore.children;
    const user_locale = getLanguageSwitcherService().localeForCountryCode(
      i18n.language
    );
    const restaurant_id = +moduleSettings.getRestaurantId();
    const pendingBooking: InitialPendingBookingRequest = {
      date,
      hour,
      persons,
      children,
      restaurant_id,
      user_locale,
    };
    const note = requestParamsImpl.overwrittenNote();
    if (note) {
      pendingBooking.note = note;
    }
    if (area_id && "all" !== area_id && !isAreaSelectionDisabled) {
      pendingBooking.area_id = area_id;
    }
    return pendingBooking;
  }
}

let createPendingBooking: CreatePendingBookingService;

export const getCreatePendingBookingService =
  (): CreatePendingBookingService => {
    if (!createPendingBooking) {
      createPendingBooking = new CreatePendingBookingService();
    }
    return createPendingBooking;
  };
